<template>
  <div class="">
    
    <div class="label-line">
      <div class="label-standard">Role</div>

      <div class="radio-line flex items-center">
        <InputRadio 
          name="inputRole"
          id="inputRoleApplicant"
          propertyKey="role"
          objectType="person"
          value="0"
          :checked="person.role == 0"
          :updateValue="updateValue" />
        
        <label class="text-base ml-2 mr-8" for="inputRoleApplicant">Applicant</label>

        <InputRadio 
          name="inputRole"
          id="inputRoleGuarantor"
          propertyKey="role"
          objectType="person"
          value="1"
          :checked="person.role == 1"
          :updateValue="updateValue" />

        <label class="text-base ml-2" for="inputRoleGuarantor">Guarantor</label>
      </div>
    </div>

    <div class="label-line">

      <div class="label-standard">Resident status</div>

      <div class="radio-line lg:flex lg:items-center">

        <InputRadio 
          name="inputresident_status"
          id="inputresident_statusCitizen"
          propertyKey="resident_status"
          objectType="person"
          value="0"
          :checked="person.resident_status == 0"
          :updateValue="updateValue" />

        <label class="text-base ml-2 mr-8" for="inputresident_statusCitizen">Citizen</label>
        <div class="visible lg:invisible block lg:hidden"></div>
        
        <InputRadio 
          name="inputresident_status"
          id="inputresident_statusPr"
          propertyKey="resident_status"
          objectType="person"
          value="1"
          :checked="person.resident_status == 1"
          :updateValue="updateValue" />

        <label class="text-base ml-2 mr-8" for="inputresident_statusPr">Permanent resident</label>
        <div class="visible lg:invisible block lg:hidden"></div>
        
        <InputRadio 
          name="inputresident_status"
          id="inputresident_statusNpr"
          propertyKey="resident_status"
          objectType="person"
          value="2"
          :checked="person.resident_status == 2"
          :updateValue="updateValue" />

        <label class="text-base ml-2" for="inputresident_statusNpr">Non-permanent resident</label>
      </div>
    </div>



    <div class="flex flex-wrap label-line">
      <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
        <TitleSelector 
          propertyKey="title"
          objectType="person"
          objectSubType="profile"
          :value="person.title"
          :updateValue="updateValue"
          :required="true"></TitleSelector>
      </div>

      <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
        <InputText 
          label="First name" 
          propertyKey="first_name"
          objectType="person"
          objectSubType="profile"
          :value="person.first_name"
          :updateValue="updateValue"
          :onKeyup="updateFirstName"
          :required="true" />
      </div>

      <div class="w-full lg:w-1/3 mt-8 lg:mt-0">
        <InputText 
          label="Surname" 
          propertyKey="last_name"
          objectType="person"
          objectSubType="profile"
          :value="person.last_name"
          :updateValue="updateValue"
          :onKeyup="updateLastName"
          :required="true" />
      </div>
    </div>

    <div class="flex flex-wrap mt-8">
      <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
        <InputText 
          label="Middle name/s" 
          propertyKey="middle_name"
          objectType="person"
          :value="person.middle_name"
          :updateValue="updateValue" />
      </div>

      <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
        <InputText 
          label="Other names you are known by"
          tooltip="Maiden name? Name change by deed poll?"
          propertyKey="other_names"
          objectType="person"
          :value="person.other_names"
          :updateValue="updateValue" />
      </div>

      <div class="w-full lg:w-1/3 mt-8 lg:mt-0">
        <InputText 
          label="Preferred name"
          propertyKey="preferred_name"
          objectType="person"
          :value="person.preferred_name"
          :updateValue="updateValue" />
      </div>
    </div>

    <div class="flex flex-wrap label-line">
      <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
        <InputEmail 
          label="Email address" 
          propertyKey="email"
          objectType="person"
          :value="person.email"
          :updateValue="updateValue"
          :copyFrom="'email'" />
      </div>

      <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
        <template v-if="!person.isPrimary">
          <a href="#" 
            class="no-underline text-white bg-blue-500 hover:bg-blue-600 font-semibold text-xs block text-center"
            style="margin-top:29px;padding:12px 8px 13px 8px;"
            @click.prevent="copyContactsFromPrimary()">Copy email &amp; home phone from primary</a>
        </template>
      </div>
    </div>

    <div class="flex flex-wrap label-line">
      <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
        <InputPhone label="Mobile phone" 
          propertyKey="mobile_phone"
          objectType="person"
          :value="person.mobile_phone"
          :updateValue="updateValue"
          :copyFrom="'mobile_phone'" />
      </div>

      <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
        <InputPhone label="Home phone" 
          propertyKey="home_phone"
          objectType="person"
          :value="person.home_phone"
          :updateValue="updateValue"
          :copyFrom="'home_phone'" />
      </div>

      <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
        <InputPhone label="Work phone" 
          propertyKey="work_phone"
          objectType="person"
          :value="person.work_phone"
          :updateValue="updateValue"
          :copyFrom="'work_phone'" />
      </div>
    </div>
    
    <div class="label-line">
      <div class="label-standard">
        <RequiredAsterisk />
        Preferred contact method
      </div>

      <div class="radio-line flex items-center">
        <InputRadio 
          name="inputContact"
          id="inputContactHome"
          propertyKey="contact_method"
          objectType="person"
          value="0"
          :checked="person.contact_method == 0"
          :updateValue="updateValue" />

        <label class="text-base ml-2" for="inputContactHome">Home phone</label>
      </div>

      <div class="mt-2 flex items-center">
        <InputRadio 
          name="inputContact"
          id="inputContactWork"
          propertyKey="contact_method"
          objectType="person"
          value="1"
          :checked="person.contact_method == 1"
          :updateValue="updateValue" />

        <label class="text-base ml-2" for="inputContactWork">Work phone</label>
      </div>

      <div class="mt-2 flex items-center">
        <InputRadio 
          name="inputContact"
          id="inputContactMobile"
          propertyKey="contact_method"
          objectType="person"
          value="2"
          :checked="person.contact_method == 2"
          :updateValue="updateValue" />

        <label class="text-base ml-2" for="inputContactMobile">Mobile</label>
      </div>

      <div class="mt-2 flex items-center">
        <InputRadio 
          name="inputContact"
          id="inputContactEmail"
          propertyKey="contact_method"
          objectType="person"
          value="3"
          :checked="person.contact_method == 3"
          :updateValue="updateValue" />

        <label class="text-base ml-2" for="inputContactEmail">Email</label>
      </div>
    </div>





    <div class="flex flex-wrap label-line">
      <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
        <InputDatePickerReadOnly 
          label="Date of birth"
          propertyKey="born_at"
          objectType="person"
          :value="person.born_at"
          :updateValue="updateValue"
          :defaultYearDiff="-30"
          :topRightLabel="person.born_at ? calculateAge(person.born_at) : null" />
      </div>

      <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
        <div class="label-standard">Gender</div>
        <div class="radio-line flex items-center">
          <InputRadio 
            name="inputGender"
            id="inputGenderMale"
            propertyKey="gender"
            objectType="person"
            value="0"
            :checked="person.gender == 0"
            :updateValue="updateValue" />
          
          <label class="text-base ml-2 mr-8" for="inputGenderMale">Male</label>
          
          <InputRadio 
            name="inputGender"
            id="inputGenderFemale"
            propertyKey="gender"
            objectType="person"
            value="1"
            :checked="person.gender == 1"
            :updateValue="updateValue" />

          <label class="text-base ml-2" for="inputGenderFemale">Female</label>
        </div>
      </div>
    </div>

    <div class="flex flex-wrap label-line">
      <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
        <div class="label-standard">
          <RequiredAsterisk />
          Marital status
        </div>        

        <div class="mt-2">
          <select 
            :value="person.marital_status == null ? -1 : person.marital_status"
            v-on:change="updateValue({
              objectType: 'person',
              key       : 'marital_status',
              value     : $event.target.value
            })"
            class="select-standard">
            <option value="-1" disabled="">Select an option...</option>
            <option value="0">Single</option>
            <option value="1">Married</option>
            <option value="2">DeFacto</option>
            <option value="3">Divorced</option>
            <option value="4">Widowed</option>
            <option value="5">Separated</option>
          </select>
        </div>
      </div>

      <div v-if="person.marital_status != 0" class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
        <SpouseName 
          :label="person.marital_status == '2' ? 'Partner name' : 'Spouse name'" 
          propertyKey="spouse_name"
          objectType="person"
          :applicant="applicant"
          :value="person.spouse_name"
          :updateValue="updateValue"></SpouseName>
      </div>
    </div>


    <div class="flex flex-wrap label-line">
      <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
        <InputText 
          propertyKey="driver_license_number"
          label="Driver's license number" 
          objectType="person"
          :value="person.driver_license_number"
          :updateValue="updateValue" />
      </div>

      <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
        <StateSelector
          propertyKey="state_id"
          objectType="person"
          :value="person.state_id"
          :updateValue="updateValue" />
      </div>

      <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
        <InputDatePicker 
          label="Expiry date"
          propertyKey="driver_license_expires_at"
          objectType="person"
          :value="person.driver_license_expires_at"
          :updateValue="updateValue"
          :defaultYearDiff="2" />
      </div>
    </div>

    <div class="flex flex-wrap label-line">
      <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
        <InputText 
          label="Mother's maiden name"
          propertyKey="maiden"
          objectType="person"
          objectSubType="profile"
          :value="person.maiden"
          :updateValue="updateValue"
          :required="true" />
      </div>

      <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
        <div class="flex items-center">
          <div class="label-standard">
            Are you a smoker?
          </div>

          <div class="ml-4" v-tooltip.top="{ html: 'smoking-tooltip' }">
            <img src="https://cdn2.iconfinder.com/data/icons/officeicons/PNG/48/Help.png" class="w-4" />
          </div>

          <div id="smoking-tooltip">This question is for applicants who are interested in reviewing their personal insurance situation.</div>
        </div>

        <div class="radio-line flex items-center">
          <InputRadio 
            name="inputSmoker"
            id="inputSmokerYes"
            propertyKey="smoker"
            objectType="person"
            value="1"
            :checked="person.smoker == 1"
            :updateValue="updateValue" />

          <label class="text-base ml-2 mr-8" for="inputSmokerYes">Yes</label>
          
          <InputRadio 
            name="inputSmoker"
            id="inputSmokerNo"
            propertyKey="smoker"
            objectType="person"
            value="0"
            :checked="person.smoker == 0"
            :updateValue="updateValue" />

          <label class="text-base ml-2" for="inputSmokerNo">No</label>
        </div>
      </div>
    </div>
      
    <div :class="{ 'mt-6' : true, 'border bg-gray-100 p-4 relative' : !person.isPrimary }">
      <a href="#" 
        v-if="!person.isPrimary"
        class="no-underline text-white bg-blue-500 hover:bg-blue-600 p-2 font-semiboldtext-xs"
        style="position:absolute;top:5px;right:5px;"
        @click.prevent="copyFromPrimary()">Copy from primary</a>

      <div class="flex flex-wrap">
        <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
          <div class="label-standard">Do you personally receive any Centrelink benefits?</div>
          
          <div class="text-gray-600 text-sm">
            Answer "No" if another applicant receives the benefits
          </div>

          <div class="mt-1 flex items-center">
            <InputRadio 
              name="inputFamilyBenefit"
              id="inputFamilyBenefitYes"
              propertyKey="family_benefits"
              objectType="person"
              value="1"
              :checked="person.family_benefits == 1"
              :updateValue="updateValue" />
            
            <label class="text-base ml-2 mr-8" for="inputFamilyBenefitYes">Yes</label>
            
            <InputRadio 
              name="inputFamilyBenefit"
              id="inputFamilyBenefitNo"
              propertyKey="family_benefits"
              objectType="person"
              value="0"
              :checked="person.family_benefits == 0"
              :updateValue="updateValue" />

            <label class="text-base ml-2" for="inputFamilyBenefitNo">No</label>
          </div>
        </div>

        <div :class="{ 'w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0 flex flex-wrap' : true, 'hidden' : person.family_benefits == 0 }">

          <div :class="{'w-full' : !isPaymentTypeOther(), 'w-1/2 pr-2' : isPaymentTypeOther() }">
            <div class="label-standard">Payment type</div>

            <div class="form-line">
              <select 
                :value="person.payment_type == null ? -1 : (!isPaymentTypeOther() ? person.payment_type : 'other')"
                v-on:change="updateValue({
                  objectType: 'person',
                  key       : 'payment_type',
                  value     : $event.target.value
                })"
                class="select-standard">
                <option value="-1" disabled="">Select an option...</option>
                <option value="family_tax_benefit_a">Family Tax Benefit A</option>
                <option value="family_tax_benefit_b">Family Tax Benefit B</option>
                <option value="pension">Pension</option>
                <option value="child_support">Child support</option>
                <option value="other">Other payment</option>
              </select>
            </div>
          </div>

          <div :class="{'hidden' : !isPaymentTypeOther(), 'w-1/2 pl-2' : isPaymentTypeOther() }">
            <InputText 
              label="Please specify"
              propertyKey="payment_type"
              objectType="person"
              :value="person.payment_type == 'other' ? null : person.payment_type"
              :updateValue="updateValue" />
          </div>
        </div>

        <div :class="{ 'w-full lg:w-1/3 flex flex-wrap' : true, 'hidden' : person.family_benefits == 0 }">
          <div class="w-1/2 pr-1">
            <InputDollarValue 
              label="Amount"
              propertyKey="family_amount"
              objectType="person"
              :value="person.family_amount"
              :updateValue="updateValue"/>
          </div>

          <div class="w-1/2 pl-2">
            <div class="label-standard text-white">.</div>

            <div class="mt-2">
              <select 
                :value="person.family_period"
                v-on:change="updateValue({
                  objectType: 'person',
                  key       : 'family_period',
                  value     : $event.target.value
                })"
                class="select-standard">
                <option value="-1" disabled="">Select an option...</option>
                <option value="0">Per Week</option>
                <option value="1">Per Fortnight</option>
                <option value="2">Per Month</option>
                <option value="3">Per Year</option>
              </select>
            </div>
          </div>
        </div>
      </div>



      <template v-if="isOldData">
        <div class="flex flex-wrap label-line">
          <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
            <div class="label-standard">Number of dependants</div>

            <div class="mt-2">
              <select class="select-standard"
                :value="person.dependants == null ? -1 : person.dependants"
                @change="updateValue({
                  obkectType: 'person',
                  key       : 'dependants', 
                  value     : $event.target.value
                })">
                <option value="-1" disabled="">Select an option...</option>
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
              </select>
            </div>
          </div>

          <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
            <InputText 
              label="Dependant ages"
              subLabel="(separate ages with commas, e.g. 5, 8)"
              propertyKey="ages"
              objectType="person"
              :value="person.ages"
              :updateValue="updateValue" />
          </div>
        </div>
      </template>

      <template v-else>
        <div class="flex flex-wrap label-line">
          <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
            <div class="flex items-center">
              <div class="text-base">Dependants</div>
              <a href="#" @click.prevent="addDependant()" class="ml-4 text-gray-600 underline hover:text-gray-800">Add</a>
            </div>

            <template v-if="dependants != null && dependants.length > 0">
              <template v-for="(dependant, index) in dependants">
                <div class="mt-4 flex flex-wrap items-center">
                  <div class="w-5/6">
                    <InputDatePickerReadOnly 
                      :index="index"
                      :label="'Dependant ' + (index + 1) + '\'s DOB'"
                      propertyKey="date_of_birth"
                      objectType="dependant"
                      :objectId="dependant.id"
                      :value="dependant.date_of_birth"
                      :updateValue="updateValue"
                      :topRightLabel="dependant.date_of_birth ? calculateAge(dependant.date_of_birth) : null" />
                  </div>

                  <div class="w-1/6 flex items-center">
                    <a href="#" @click.prevent="deleteDependant(index, dependant.id)" style="margin-top:29px;" class="text-gray-600 hover:text-red-500 hover:underline ml-2">Delete</a>
                  </div>
                </div>
              </template>
            </template>

            <template v-if="dependants != null && dependants.length == 0">
              <div class="text-sm text-gray-700 mt-2">You have not added any dependants.</div>
            </template>
          </div>
        </div>
      </template>
    </div>

    <div class="mt-8" v-if="person.isPrimary">
      <NearestRelative></NearestRelative>
    </div>
  </div>
</template>

<script>
  import moment           from 'moment'
  import TitleSelector    from '@/shared/components/form/TitleSelector'
  import StateSelector    from '@/shared/components/form/StateSelector'
  import InputText        from '@/shared/components/form/InputText'
  import InputEmail       from '@/shared/components/form/InputEmail'
  import InputPhone       from '@/shared/components/form/InputPhone'
  import RequiredAsterisk from '@/shared/components/form/RequiredAsterisk'
  import SpouseName       from '@/shared/components/form/SpouseName'
  import InputRadio       from '@/shared/components/form/InputRadio'
  import InputDatePicker  from '@/shared/components/form/InputDatePicker'
  import InputDollarValue from '@/shared/components/form/InputDollarValue'
  import NearestRelative  from './NearestRelative'

  import InputDatePickerReadOnly from '@/shared/components/form/InputDatePickerReadOnly'

  export default {

    props : {
      applicant : {
        type     : Object,
        required : true
      }
    },

    components: {
      TitleSelector,
      StateSelector,
      InputText,
      InputEmail,
      InputPhone,
      RequiredAsterisk,
      SpouseName,
      InputRadio,
      InputDatePicker,
      InputDollarValue,
      NearestRelative,
      InputDatePickerReadOnly
    },

    computed : {
      person() {
        return this.applicant.person
      },

      isOldData() {
        // console.log(this.applicant)
        return this.getEnv == 'production' && this.applicant.id < 1153351
      }
    },

    data() {
      return {
        dependants : null
      }
    },

    created() {
      this.getDependants()
    },

    watch: {
      '$route' (to, from) {
        this.getDependants()
      }
    },

    methods : {
      getDependants() {
        this.apiGet({
          clientId   : this.$route.params.clientId,
          applicantId: this.$route.params.applicantId,
        }, 'applicant/dependants', (dependants) => {
          this.dependants = dependants
        })
      },

      copyContactsFromPrimary() {
        // this.person.email = this.$store.state[this.$store.state.view + 'Module'].client.applicants[0].person.email
        // this.person.home_phone    = this.$store.state[this.$store.state.view + 'Module'].client.applicants[0].person.home_phone
        this.updatePerson(this.person, [{
          key  : 'email',
          value: this.$store.state[this.$store.state.view + 'Module'].client.applicants[0].person.email
        }, {
          key  : 'home_phone',
          value: this.$store.state[this.$store.state.view + 'Module'].client.applicants[0].person.home_phone
        }])
      },
      
      // a method that will receive the value and update
      updateValue(params) {
        if(params.objectType == 'person') {
          let changes = [{
            key  : params.key,
            value: params.value
          }]

          // if title, change the gender
          if(params.key == 'title') {
            let gender = null
            if(parseInt(params.value) == 0) {
              gender = 0;
            } else if(_.indexOf([1,2,3], parseInt(params.value)) > -1) {
              gender = 1;
            }

            changes.push({
              key  : 'gender',
              value: gender
            })
          }

          this.updatePerson(this.person, changes)
        }

        else if(params.objectType == 'dependant') {
          let d = this.dependants[params.index]
          d.date_of_birth = params.value
          this.$set(this.dependants, params.index, d)
          this.apiPost({
            clientId   : this.$route.params.clientId,
            dependantId: params.objectId,
            dateOfBirth: params.value
          }, 'applicant/dependant', () => {

          })
        }
      },

      updateFirstName(value) {
        this.$store.commit(this.$store.state.view + "Module/setApplicantName", {
          firstName  : value,
          applicantId: this.applicant.id
        })
      },

      updateLastName(value) {
        this.$store.commit(this.$store.state.view + "Module/setApplicantName", {
          lastName   : value,
          applicantId: this.applicant.id
        })
      },

      populatePreferredNames() {
        let arr = []

        if(this.person.first_name != null && this.person.first_name.length > 0) {
          arr.push({
            id         : this.person.first_name,
            name       : this.person.first_name,
            description: this.person.first_name            
          })
        }

        if(this.person.last_name != null && this.person.last_name.length > 0) {
          arr.push({
            id         : this.person.last_name,
            name       : this.person.last_name,
            description: this.person.last_name
          }) 
        }

        if(this.person.other_names != null && this.person.other_names.length > 0) {
          arr.push({
            id         : this.person.other_names,
            name       : this.person.other_names,
            description: this.person.other_names            
          }) 
        }

        return arr
      },

      copyFromPrimary() {

        let arr = [{
          key  : 'dependants',
          value: this.$store.state[this.$store.state.view + 'Module'].client.applicants[0].person.dependants
        }, {
          key  : 'ages',
          value: this.$store.state[this.$store.state.view + 'Module'].client.applicants[0].person.ages
        }, {
          key  : 'family_benefits',
          value: this.$store.state[this.$store.state.view + 'Module'].client.applicants[0].person.family_benefits
        }, {
          key  : 'family_amount',
          value: this.$store.state[this.$store.state.view + 'Module'].client.applicants[0].person.family_amount
        }, {
          key  : 'family_period',
          value: this.$store.state[this.$store.state.view + 'Module'].client.applicants[0].person.family_period          
        }]

        // update the server
        this.updatePerson(this.person, arr, () => {
          // this.person.dependants     = this.$store.state[this.$store.state.view + 'Module'].client.applicants[0].person.dependants
          // this.person.ages           = this.$store.state[this.$store.state.view + 'Module'].client.applicants[0].person.ages
          // this.person.family_benefits = this.$store.state[this.$store.state.view + 'Module'].client.applicants[0].person.family_benefits
          // this.person.family_amount   = this.$store.state[this.$store.state.view + 'Module'].client.applicants[0].person.family_amount
          // this.person.family_period   = this.$store.state[this.$store.state.view + 'Module'].client.applicants[0].person.family_period          
        })

        this.apiPost({
          clientId   : this.$route.params.clientId,
          applicantId: this.$route.params.applicantId,
        }, 'applicant/copy-dependants-from-primary', (dependants) => {
          this.dependants = dependants
        })
      },

      isPaymentTypeOther() {
        if(this.person.payment_type == null || 
           this.person.payment_type == 'family_tax_benefit_a' ||
           this.person.payment_type == 'family_tax_benefit_b' ||
           this.person.payment_type == 'pension' || 
           this.person.payment_type == 'child_support') {
          return false
        }

        return true
      },

      addDependant() {
        this.apiPost({
          clientId   : this.$route.params.clientId,
          applicantId: this.$route.params.applicantId,
        }, 'applicant/dependant', (dependant) => {
          if(this.dependants == null) {
            this.dependants = [dependant]
          }

          else {
            this.dependants.push(dependant)
          }
        })
      },

      deleteDependant(index, id) {
        this.dependants.splice(index, 1)

        this.apiDelete({
          clientId   : this.$route.params.clientId,
          dependantId: id
        }, 'applicant/dependant', () => {

        })
      }
    }
  }
</script>